<template>
  <v-breadcrumbs v-if="navigationStack.length || selectedFolder" class="pa-0 d-flex align-center">
    <v-breadcrumbs-item class="breadcrumb-link px-1" @click="resetNavigation">Inicio</v-breadcrumbs-item>

    <div v-for="(folder, index) in navigationStack" :key="index">
      <span class="divider-bread">·</span>
      <v-breadcrumbs-item class="breadcrumb-link px-1" @click.prevent="goToFolder(index)">
        {{ folder.name }}
      </v-breadcrumbs-item>
    </div>

    <div v-if="selectedFolder">
      <span class="divider-bread">·</span>
      <v-breadcrumbs-item class="px-1" disabled>{{ selectedFolder.name }}</v-breadcrumbs-item>
    </div>
  </v-breadcrumbs>

</template>

<script>
export default {
  name: 'Breadcrumbs',
  props: {
    navigationStack: {
      type: Array,
      required: true
    },
    selectedFolder: {
      type: Object,
      default: null
    }
  },
  methods: {
    resetNavigation() {
      this.$emit('reset-navigation');
    },
    goToFolder(index) {
      this.$emit('go-to-folder', index);
    }
  }
};
</script>
